import { render, staticRenderFns } from "./Agua.vue?vue&type=template&id=36675e93&scoped=true"
import script from "./Agua.vue?vue&type=script&lang=js"
export * from "./Agua.vue?vue&type=script&lang=js"
import style0 from "./Agua.vue?vue&type=style&index=0&id=36675e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36675e93",
  null
  
)

export default component.exports